import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Medium = (_jsx("svg", Object.assign({ id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16.2 16.2" }, { children: _jsx("path", { fill: "var(--pink-base)", d: "M8.1.48A7.62,7.62,0,1,0,15.72,8.1,7.62,7.62,0,0,0,8.1.48ZM12.3,5,9.18,8.1l3.12,3.12L11.22,12.3,8.1,9.18,5,12.3,3.9,11.22,7,8.1,3.9,5,5,3.9,8.1,7,11.22,3.9Z" }, void 0) }), void 0));
export const variants = {
    medium: Medium,
    default: Medium,
};
export default withVariants(variants);
